import cn from "classnames";
export const styles = {
  container_ssg: "",
  container:
    "w-full hyam-layout-container bg-hyam-black border-white border-t-[1px] z-50",

  //target bold text
  layout_container: cn(
    "hyam-slice-container hyam-layout relative",
    // "[&_strong]:!text-white",
    "[&_strong]:font-body [&_strong]:antialiased [&_strong]:font-semibold [&_strong]:!text-m-medium [&_strong]:!text-white [&_strong]:!block [&_strong]:!mb-6",
  ),
  top_section:
    "hyam-cols border-b border-hyam-white mb-10 pb-6",
  middle_section:
    "hyam-cols border-b border-hyam-white mb-10 pb-6",
  bottom_section: "hyam-cols",

  column_rich_text: cn(
    "col-span-3 relative",
    // "col-span-3 flex justify-between",
    // NOTE: blank lines between address blocks come from the trailing <br> that
    // Prismic renders for a trailing newline; do not restyle <br> or it collapses.
  ),

  column_rich_text_button: cn(
    "absolute bottom-0 mb-4",
    "text-hyam-white uppercase",
    "hover:decoration-hyam-white hyam-animate-text-white",
  ),

  // no mb-0: keep hyam-text-small's mb-6 so the 4 address paragraphs stay spaced apart
  rich_text_all: "text-hyam-white",
  rich_text_paragraph: "hyam-text-small",
  // mb-0: links sit inside a paragraph, so the block gap stays on the <p>, not each link
  rich_text_hyperlink: "hyam-text-small mb-0",

  column_links_with_title: "col-span-3",
  column_title: "block mb-6 text-m-medium",
  column_link:
    "hyam-text-small text-hyam-white uppercase block mb-4",
  image_container: "pt-10 xl:pt-20 relative",

  column_action_items: "col-span-3",
  column_action_item_title: "",
  column_action_item_link: cn(
    "text-hyam-white uppercase h-6 py-5",
    "hover:decoration-hyam-white hyam-animate-text-white",
  ),
  column_action_item_social: "h-6",
  column_action_item_social_link: "mr-8 h-6",
};

export type HyamPrismicDocumentFooterStyles =
  typeof styles;
